import { deliveryMethods } from '@prolaera/library';
import { find } from 'lodash';

/* @ngInject */
export default class {
  constructor($q, $log, JwtClass) {
    this.JwtClass = JwtClass;
    this.$q = $q;
    this.$log = $log;

    this.delivery_methods = deliveryMethods
      .filter(method => method.delivery_types && method.delivery_types.event)
      .map(({ key }) => key);
  }

  isEvent({ delivery_method }) {
    return this.delivery_methods.includes(delivery_method);
  }

  isGroupLive({ delivery_method }) {
    return delivery_method === 1 || delivery_method === 10;
  }

  externalWebinars(event) {
    const webinars = (event.externals || []).filter(
      ({ type }) =>
        'zoomExternal' || type === 'gtwEventExternal' || type === 'webexExternal' || type === 'otherExternal'
    );
    return webinars;
  }

  externalFetchedWebinars(event) {
    const webinars = (event.externals || []).filter(
      ({ type, fetched }) => ('zoomExternal' || type === 'gtwEventExternal' || type === 'webexExternal') && !!fetched
    );
    return webinars;
  }

  hasCustomHours(event) {
    const hasCustomHours = (event.externals || []).some(({ type }) => type === 'cnfExternal');
    return hasCustomHours;
  }

  hasCodeWords(event, registrants) {
    const codeWords = (event.externals || []).some(({ type }, index) => {
      if (type === 'cnfExternal') {
        return registrants.some(registrant => {
          const hasSession = registrant.sessions && registrant.sessions[index];
          if (hasSession && registrant.sessions[index].fieldOfStudy) {
            return registrant.sessions[index].fieldOfStudy.some(field => field.codewords);
          }
          return false;
        });
      }
      return false;
    });
    return codeWords;
  }

  isWebinar({ type }) {
    return (
      type === 'zoomExternal' || type === 'gtwEventExternal' || type === 'webexExternal' || type === 'otherExternal'
    );
  }

  isWebinarRegistration({ type }) {
    return type === 'zoom' || type === 'goToWebinar' || type === 'webex' || type === 'other';
  }

  setStatus(event, location) {
    if (location && event && event.registration && location !== event.registration.location) {
      delete event.status;
    }

    if (event.status === 'purchase' && event.passes && event.passes.length) {
      event.status = 'Redeem Pass';
    }
  }

  getWaitlist(event, locationOverride) {
    const config = { waitlist: false, full: false };

    if (!event) {
      return config;
    }

    const location = find(event.locations, { location: locationOverride });

    if (
      ((!locationOverride || locationOverride == event.delivery_location) && event.registrationOpenings < 1) ||
      (location && location.registrationOpenings < 1)
    ) {
      if (event.waitlist === 'off') {
        config.full = true;
      } else {
        config.waitlist = true;
      }
    }

    return config;
  }
}



// WEBPACK FOOTER //
// ./src/app/services/EventClass.js